<script setup>
import { inject } from 'vue'
import { customAlert } from '@general/js/utils/swalMessages'
import { eventNames } from 'process'

const props = defineProps({
    date: {
        type: String,
        default: '',
    },
    documentTypes: {
        type: Array,
        default: [],
    },
    typeClaims: {
        type: Array,
        default: [],
    },
    typeContractedAssets: {
        type: Array,
        default: [],
    },
    url: {
        type: String,
        default: '',
    },
})

const loading = inject('loading')

const submit = async (event) => {
    loading.value = true

    try {
        const formData = new FormData(event.target)
        const { data } = await axios.post(props.url, formData)

        loading.value = false
        customAlert(data)

        if (data?.type === 1) {
            event.target.reset()
            document.getElementById('creation_date').value = props.date
        }
    } catch (error) {
        loading.value = false
        console.log(error)
    }
}
</script>

<template>
    <form @submit.prevent="submit($event)" class="complaints-book-form">
        <div class="input-group input-group--one">
            <div class="input-box">
                <label for="creation_date">Fecha</label>
                <input
                    type="text"
                    id="creation_date"
                    name="creation_date"
                    :value="date"
                    readonly="true"
                />
            </div>
        </div>
        <div class="form-title">1. Identificación del Consumidor reclamante</div>
        <div class="input-group input-group--two">
            <div class="input-box">
                <label for="full_name">Nombre completo</label>
                <input type="text" id="full_name" name="full_name" />
            </div>
            <div class="input-box">
                <label for="address">Domicilio</label>
                <input type="text" id="address" name="address" />
            </div>
            <div class="input-box">
                <label for="document_type">Documento de Identidad</label>
                <select name="document_type" id="document_type">
                    <option value="">Seleccionar...</option>
                    <option
                        v-for="documentType in documentTypes"
                        :key="documentType.id"
                        :value="documentType.content"
                    >
                        {{ documentType.content }}
                    </option>
                </select>
            </div>
            <div class="input-box">
                <label for="document_number">Nº de Documento</label>
                <input type="text" id="document_number" name="document_number" />
            </div>
            <div class="input-box">
                <label for="email">E-mail</label>
                <input type="email" id="email" name="email" />
            </div>
            <div class="input-box">
                <label for="phone_number">Teléfono</label>
                <input type="tel" id="phone_number" name="phone_number" />
            </div>
        </div>
        <div class="input-group input-group--three">
            <div class="input-box">
                <label for="parent_full_name">Nombre completo del Padre o Madre</label>
                <input type="text" id="parent_full_name" name="parent_full_name" />
            </div>
            <div class="input-box">
                <label for="parent_document_type">Documento de Identidad</label>
                <select name="parent_document_type" id="parent_document_type">
                    <option value="">Seleccionar...</option>
                    <option
                        v-for="documentType in documentTypes"
                        :key="documentType.id"
                        :value="documentType.content"
                    >
                        {{ documentType.content }}
                    </option>
                </select>
            </div>
            <div class="input-box">
                <label for="parent_document_number">Nº de Documento</label>
                <input type="text" id="parent_document_number" name="parent_document_number" />
            </div>
        </div>
        <div class="form-title">2. Identificación del Bien contratado</div>
        <div class="input-group input-group--four">
            <div class="input-box">
                <label for="type_contracted_asset">Tipo del bien contratado</label>
                <select name="type_contracted_asset" id="type_contracted_asset">
                    <option
                        v-for="typeContractedAsset in typeContractedAssets"
                        :key="typeContractedAsset.id"
                        :value="typeContractedAsset.content"
                    >
                        {{ typeContractedAsset.content }}
                    </option>
                </select>
            </div>
            <div class="input-box">
                <label for="amount">Monto reclamado</label>
                <input type="text" id="amount" name="amount" />
            </div>
            <div class="input-box">
                <label for="description">Descripción</label>
                <input type="text" id="description" name="description" />
            </div>
        </div>
        <div class="form-title">3. Detalle de la reclamación y pedido del Consumidor</div>
        <div class="input-group input-group--five">
            <div class="input-box">
                <label for="type_claim">Tipo de reclamo</label>
                <select name="type_claim" id="type_claim">
                    <option
                        v-for="typeClaim in typeClaims"
                        :key="typeClaim.id"
                        :value="typeClaim.content"
                    >
                        {{ typeClaim.content }}
                    </option>
                </select>
            </div>
        </div>
        <div class="input-group input-group--six">
            <div class="input-box">
                <label for="detail">Detalle</label>
                <textarea name="detail" id="detail" size="20"></textarea>
            </div>
            <div class="input-box">
                <label for="request">Pedido</label>
                <textarea name="request" id="request" size="20"></textarea>
            </div>
        </div>
        <div class="form-title">4. Observaciones y Acciones adoptadas por el Proveedor</div>
        <div class="input-group input-group--seven">
            <div class="input-box">
                <label for="response_date">Fecha de comunicación</label>
                <input type="text" name="response_date" id="response_date" readonly />
            </div>
        </div>
        <div class="input-group input-group--eight">
            <div class="input-box">
                <label for="response">Detalle</label>
                <textarea name="response" id="response" size="20" readonly></textarea>
            </div>
        </div>
        <ul class="complaints-book-form__notes">
            <li>
                <strong>RECLAMO:</strong> Disconformidad relacionada a los productos o servicios.
            </li>
            <li>
                <strong>QUEJA:</strong> Disconformidad no relacionadaa los productos o servicios; o,
                malestar o descontento respecto a la atención al público.
            </li>
            <li>
                * La formulación del reclamo no impide acudir a otras vías de solución de
                controversias ni es requisito previo para interponer una denuncia ante el INDECOPI.
            </li>
            <li>
                * El proveedor debe dar respuesta al reclamo o queja en un plazo no mayor a quince
                (15) días hábiles, el cual es improrrogable.
            </li>
        </ul>
        <div class="input-group">
            <button class="btn">Enviar</button>
        </div>
    </form>
</template>

<style lang="scss" scoped>
$md: 768px;
$lg: 1024px;

.complaints-book-form {
    margin: 0 auto;
    max-width: 924px;

    .form-title {
        color: #000;
        font-weight: bold;
        margin: 2rem 0;
    }

    .input-group {
        align-items: flex-end;
        display: grid;
        gap: 1.5rem;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        margin-bottom: 1.5rem;

        @media (min-width: $lg) {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }

        &--two {
            .input-box {
                &:first-child {
                    grid-column: 1 / 3;
                }

                &:nth-child(2) {
                    grid-column: 1 / 3;

                    @media (min-width: $lg) {
                        grid-column: 3 / 5;
                    }
                }
            }
        }

        &--three {
            .input-box {
                &:first-child {
                    grid-column: 1 / 3;
                }
            }
        }

        &--five {
            align-items: flex-start;
        }

        &--six {
            grid-template-columns: repeat(1, minmax(0, 1fr));

            @media (min-width: $lg) {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }

        &--eight {
            grid-template-columns: 1fr;
        }

        textarea {
            height: 200px;
        }
    }

    &__notes {
        display: grid;
        font-size: 0.875rem;
        gap: 1rem;
        grid-template-columns: repeat(1, 1fr);
        list-style: none;
        margin: 2rem 0;
        padding: 0;
    }
}
</style>
